(function () {
  'use strict';

  var popups = document.querySelectorAll('[data-pc-engagement-popup]');
  if (!popups.length) return;

  function handles(value) {
    return String(value || '').toLowerCase().split(/[\n,]+/).map(function (item) {
      return item.trim().replace(/^\/+|\/+$/g, '');
    }).filter(Boolean);
  }

  function canShow(popup) {
    var pageType = popup.getAttribute('data-popup-page-type') || '';
    var displayOn = popup.getAttribute('data-popup-display-on') || 'all';
    var pageHandle = popup.getAttribute('data-popup-page-handle') || '';
    var collectionHandle = popup.getAttribute('data-popup-collection-handle') || '';
    var productHandle = popup.getAttribute('data-popup-product-handle') || '';
    var isCustomer = popup.getAttribute('data-popup-customer') === 'true';
    var visitorType = popup.getAttribute('data-popup-visitor-type') || 'all';

    if (displayOn === 'home' && pageType !== 'index') return false;
    if (displayOn !== 'all' && displayOn !== 'home' && displayOn !== pageType) return false;
    if (popup.getAttribute('data-popup-exclude-cart') === 'true' && pageType === 'cart' && displayOn !== 'cart') return false;
    if (visitorType === 'guest' && isCustomer) return false;
    if (visitorType === 'customer' && !isCustomer) return false;

    var includePages = handles(popup.getAttribute('data-popup-include-pages'));
    var includeCollections = handles(popup.getAttribute('data-popup-include-collections'));
    var includeProducts = handles(popup.getAttribute('data-popup-include-products'));
    var hasIncludes = includePages.length || includeCollections.length || includeProducts.length;
    var matchesIncludedPage = pageType === 'page' && includePages.indexOf(pageHandle) !== -1;
    var matchesIncludedCollection = pageType === 'collection' && includeCollections.indexOf(collectionHandle) !== -1;
    var matchesIncludedProduct = pageType === 'product' && includeProducts.indexOf(productHandle) !== -1;
    if (hasIncludes && !matchesIncludedPage && !matchesIncludedCollection && !matchesIncludedProduct) return false;
    if (handles(popup.getAttribute('data-popup-exclude-pages')).indexOf(pageHandle) !== -1 && pageHandle) return false;
    if (handles(popup.getAttribute('data-popup-exclude-collections')).indexOf(collectionHandle) !== -1 && collectionHandle) return false;
    if (handles(popup.getAttribute('data-popup-exclude-products')).indexOf(productHandle) !== -1 && productHandle) return false;
    return true;
  }

  function wasShown(popup) {
    if (popup.getAttribute('data-popup-design-mode') === 'true') return false;
    var frequency = popup.getAttribute('data-popup-frequency') || 'once_session';
    var id = popup.getAttribute('data-popup-id') || 'default';
    var now = Date.now();
    try {
      if (frequency === 'once_session') return window.sessionStorage.getItem('pc-popup:' + id) === '1';
      if (frequency === 'once_day' || frequency === 'once_week' || frequency === 'once_month') {
        var shownAt = Number(window.localStorage.getItem('pc-popup:' + id) || 0);
        var intervals = { once_day: 86400000, once_week: 604800000, once_month: 2592000000 };
        return shownAt > 0 && now - shownAt < intervals[frequency];
      }
    } catch (error) {}
    return false;
  }

  function recordShown(popup) {
    if (popup.getAttribute('data-popup-design-mode') === 'true') return;
    var frequency = popup.getAttribute('data-popup-frequency') || 'once_session';
    var id = popup.getAttribute('data-popup-id') || 'default';
    try {
      if (frequency === 'once_session') window.sessionStorage.setItem('pc-popup:' + id, '1');
      if (frequency === 'once_day' || frequency === 'once_week' || frequency === 'once_month') window.localStorage.setItem('pc-popup:' + id, String(Date.now()));
    } catch (error) {}
  }

  popups.forEach(function (popup) {
    var designMode = popup.getAttribute('data-popup-design-mode') === 'true';
    if (!designMode && (!canShow(popup) || wasShown(popup))) return;

    var trigger = popup.getAttribute('data-popup-trigger') || 'delay';
    var device = popup.getAttribute('data-popup-device') || 'all';
    var mobile = window.matchMedia && window.matchMedia('(max-width: 700px)').matches;
    if (!designMode && device === 'desktop' && mobile) return;
    if (!designMode && device === 'mobile' && !mobile) return;

    var dialog = popup.querySelector('[role="dialog"]');
    var closeButton = popup.querySelector('[data-pc-popup-close]');
    var backdrop = popup.querySelector('[data-pc-popup-backdrop]');
    var previousFocus = null;
    var opened = false;
    var timer = null;

    function openPopup() {
      if (opened) return;
      opened = true;
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('pc-engagement-popup-open');
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
      recordShown(popup);
      window.dispatchEvent(new CustomEvent('coreiq:engagement-popup:shown', { detail: { popupId: popup.getAttribute('data-popup-id') } }));
      if (closeButton) closeButton.focus();
    }

    function closePopup() {
      if (!opened) return;
      opened = false;
      popup.classList.remove('is-open');
      document.body.classList.remove('pc-engagement-popup-open');
      window.setTimeout(function () { popup.hidden = true; }, 230);
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      window.dispatchEvent(new CustomEvent('coreiq:engagement-popup:closed', { detail: { popupId: popup.getAttribute('data-popup-id') } }));
    }

    popup.querySelectorAll('[data-pc-popup-close]').forEach(function (button) { button.addEventListener('click', closePopup); });
    if (backdrop && popup.getAttribute('data-popup-close-backdrop') === 'true') backdrop.addEventListener('click', closePopup);
    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }
      if (event.key !== 'Tab' || !dialog) return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (item) { return item.offsetParent !== null; });
      if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    if (designMode) {
      openPopup();
      return;
    }

    if (trigger === 'delay') {
      timer = window.setTimeout(openPopup, Math.max(3, Number(popup.getAttribute('data-popup-delay')) || 8) * 1000);
    } else if (trigger === 'scroll') {
      var threshold = Math.min(90, Math.max(10, Number(popup.getAttribute('data-popup-scroll')) || 50));
      var onScroll = function () {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0 || (window.scrollY / scrollable) * 100 >= threshold) {
          window.removeEventListener('scroll', onScroll);
          openPopup();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (trigger === 'exit_intent' && mobile) {
      timer = window.setTimeout(openPopup, Math.max(3, Number(popup.getAttribute('data-popup-delay')) || 8) * 1000);
    } else if (trigger === 'exit_intent') {
      var onExit = function (event) {
        if (event.clientY <= 0 && !event.relatedTarget) {
          document.removeEventListener('mouseout', onExit);
          openPopup();
        }
      };
      document.addEventListener('mouseout', onExit);
    }
  });
}());
